import { DATA_SOURCE_OPTIONS } from '../utils/ledgerLineItems';

export const buildSalesTaxFilterGroups = (filterOptions = {}, venueOwnerships = [], generalLedgerCodesEnabled = false) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: (venueOwnerships || []).map(o => ({
          value: String(o.id),
          label: o.name,
        })),
      },
    ],
  },
  {
    id: 'tax',
    label: 'Tax',
    filters: [
      {
        id: 'tax_name',
        label: 'Tax Name',
        type: 'checkbox',
        options: (filterOptions.tax_name_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
      ...(generalLedgerCodesEnabled ? [{
        id: 'general_ledger_code',
        label: 'GL Code',
        type: 'checkbox',
        options: (filterOptions.general_ledger_code_options || []).map(o => ({
          value: o,
          label: o,
        })),
      }] : []),
    ],
  },
  {
    id: 'data',
    label: 'Data',
    filters: [
      {
        id: 'data_source',
        label: 'Origin',
        type: 'checkbox',
        options: DATA_SOURCE_OPTIONS,
      },
      {
        id: 'import_run_id',
        label: 'Import Run',
        type: 'search',
        options: (filterOptions.import_run_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
    ],
  },
];
